module.exports = __webpack_public_path__ + "static/media/ico2-checklist.04aaf6a2.svg";